import { useState } from 'react'
import PublicLayout from '../layouts/PublicLayout'
import FixtureCard from '../components/FixtureCard'
import usePoll from '../hooks/usePoll'
import { track } from '../lib/events'

const FILTERS = [
  ['tudo', 'Tudo'],
  ['groupA', 'Grupo A'],
  ['groupB', 'Grupo B'],
  ['field1', 'Campo 1'],
  ['field2', 'Campo 2'],
  ['knockout', 'Eliminatórias'],
]

function matchPasses(m, filter) {
  switch (filter) {
    case 'tudo':
      return true
    case 'groupA':
      return m.stage === 'group' && m.group === 'A'
    case 'groupB':
      return m.stage === 'group' && m.group === 'B'
    case 'field1':
      return m.field === 1
    case 'field2':
      return m.field === 2
    case 'knockout':
      return m.stage !== 'group'
    default:
      return true
  }
}

export default function Schedule({ currentEdition, editions, slots = [] }) {
  const [filter, setFilter] = useState('tudo')
  usePoll(15000)

  function pickFilter(key) {
    setFilter(key)
    track('schedule-filter-changed', { filter: key })
  }

  const visibleSlots = slots
    .map((s) => ({ ...s, matches: s.matches.filter((m) => matchPasses(m, filter)) }))
    .filter((s) => s.matches.length > 0)

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="calendario">
      <div className="filters">
        {FILTERS.map(([key, label]) => (
          <span
            key={key}
            className={`f ${filter === key ? 'on' : ''}`}
            onClick={() => pickFilter(key)}
          >
            {label}
          </span>
        ))}
      </div>

      {visibleSlots.map((slot) => (
        <div className="slot" key={slot.time}>
          <div className="time">{slot.time}</div>
          <div className="fixtures">
            {slot.matches.map((m) => (
              <FixtureCard key={m.gameNumber} match={m} />
            ))}
          </div>
        </div>
      ))}
    </PublicLayout>
  )
}
